import {
  titleUI,
  dateUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { isLessThan180DaysInFuture } from 'applications/disability-benefits/shared/utils/dates';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import { getPageTitle } from '../../utils/conditionalLogic';
import { reviewDateField } from '../../components/ReviewDateField';

const { serviceInformation } = fullSchema.properties;

const SEPARATION_DATE_TITLE = 'Anticipated separation date';

export default {
  uiSchema: {
    ...titleUI(props =>
      getPageTitle({ ...props, text: 'Anticipated separation date from the' }),
    ),
    serviceInformation: {
      federalActivation: {
        // `any` leaves the range to isLessThan180DaysInFuture (v1's messages and bounds).
        anticipatedSeparationDate: {
          ...dateUI({
            title: SEPARATION_DATE_TITLE,
            allowedDates: 'any',
            required: () => true,
            monthSelect: false,
            validations: [isLessThan180DaysInFuture],
            errorMessages: { pattern: 'Provide a valid date' },
          }),
          'ui:reviewField': reviewDateField,
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['serviceInformation'],
    properties: {
      serviceInformation: {
        type: 'object',
        required: ['federalActivation'],
        properties: {
          federalActivation: {
            type: 'object',
            required: ['anticipatedSeparationDate'],
            properties: {
              anticipatedSeparationDate:
                serviceInformation.properties.federalActivation.properties
                  .anticipatedSeparationDate,
            },
          },
        },
      },
    },
  },
};
